import { useQuery } from "@tanstack/react-query";
import { useSelector } from "../../../../../store/store";
import { HOSummaryEmployeeRequestService } from "../../../../../services/human-organization/summary-register-request.service";

export const useGetMyRequests = () => {
  const user = useSelector((state) => state.user);
  const currentUserName = user?.current?.username;

  const response = useQuery({
    queryKey: ["my-summary-registration-courses", currentUserName],
    queryFn: () =>
    HOSummaryEmployeeRequestService.getSummaryEmployeeRequests(currentUserName),
    refetchOnMount:"always"
  });

  return response;
};
